import React from 'react'

class Status extends React.Component {
  render() {
    return (
      <div>
        Status
        <span className="ml-2 p-1 badge bg-danger text-white font-size-12 text-uppercase">
          Trialing
        </span>
      </div>
    )
  }
}

export default Status
